import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Modal from './shared/modal';
import ConfirmRemoveDialog from './ConfirmRemoveDialog';
import { commentsList, newComment, removeComment, updateComment } from '../services/comments';

const CommentsButton = ({ entityType }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [show, setShow] = useState(false);

  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState('');
  const [commentToRemove, setCommentToRemove] = useState(null);

  const loadComments = async () => {
    if (!id) return;
    const { comments } = await commentsList(entityType, id);
    setComments(comments);
  }

  useEffect(() => {
    loadComments();
  }, []);

  const saveComment = async () => {
    if (!commentText.trim()) return;
    if (commentToRemove) {
      await updateComment(commentToRemove.id, { content: commentText });
    } else {
      await newComment(entityType, id, { content: commentText });
    }
    closeModal();
    loadComments();
  };

  const confirmRemove = async () => {
    if (!commentToRemove) return;
    await removeComment(commentToRemove.id);
    setCommentToRemove(null);
    loadComments();
  };

  const openModalForEdit = (comment = null) => {
    setCommentText(comment ? comment.content : '');
    setCommentToRemove(comment);
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
    setCommentText('');
    setCommentToRemove(null);
  };

  return (
    <div className="form-container-content-right-narrow">
      <div className="heading">{t('exercises.form.title')}</div>
      {comments.map(comment => (
        <div className="comment-card" key={comment.id}>
          <pre
            className="comment-card-text"
            onClick={() => openModalForEdit(comment)}
            dangerouslySetInnerHTML={{ __html: comment.content }}
          />
          <i className="icon-trash delete-comment" onClick={() => setCommentToRemove(comment)}></i>
        </div>
      ))}
      <button className="button button-add" onClick={() => openModalForEdit()}>
        {t('exercises.form.add')}
      </button>

      <Modal openModal={show} closeModal={closeModal}>
        <div className="flex1 flex-column comment-dialog">
          <h4>{commentToRemove ? t('comments.update') : t('comments.title')}</h4>
          <form
            onSubmit={e => {
              e.preventDefault();
              saveComment();
            }}
          >
            <textarea
              name="content"
              placeholder={t('comments.placeholder')}
              rows="4"
              className="custom-textarea"
              value={commentText}
              onChange={e => setCommentText(e.target.value)}
            />
            <div className="form-container-actions">
              <div className="flex-end">
                <button className="button" onClick={closeModal}>
                  {t('buttons.common.cancel')}
                </button>
                <button type="submit" className="button button-primary">
                  {commentToRemove ? t('buttons.common.update') : t('buttons.common.save')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {commentToRemove && (
        <ConfirmRemoveDialog
          title={t('comments.remove_comment')}
          confirm={confirmRemove}
          close={() => setCommentToRemove(null)}
        />
      )}
    </div>
  );
};

export default CommentsButton;

